import axios from 'axios'
import { useEffect } from 'react'

import { SESSION_TOKEN } from '@/utils/constants'
import { API_URL } from '@/services/api/config'

export default function OAuthRelayPage() {
  useEffect(() => {
    const url = new URL(window.location.href)
    const srcParams = url.searchParams

    const apiOrigin = new URL(API_URL).origin
    const sessionToken = localStorage.getItem(SESSION_TOKEN)

    if (!sessionToken) {
      /** TODO: continue is not implemented. */
      return
    }

    const pass = new URLSearchParams()

    for (const key of [
      'response_type',
      'client_id',
      'redirect_uri',
      'scope',
      'state',
      'code_challenge',
      'code_challenge_method',
      'resource',
    ]) {
      const v = srcParams.get(key)
      if (v) pass.set(key, v)
    }

    axios
      .get(`${apiOrigin}/oauth/authorize`, {
        params: pass,
        headers: {
          Authorization: `Bearer ${sessionToken}`,
          Accept: 'application/json'
        },
        withCredentials: false
      })
      .then(({ data }) => {
        const redirectUri: string | undefined = data?.redirect_uri
        if (redirectUri) {
          window.location.replace(redirectUri)
        }
      })
      .catch(() => {
        // No-op; user can retry the flow
      })
  }, [])

  return null
}
